export enum OrderType {
    TAKEAWAY = 'TAKEAWAY',
    ON_SITE = 'ON_SITE',
    DELIVERY = 'DELIVERY',
    EVENT = 'EVENT',
}
